import Button from 'shared/Buttons/Button/Button'
import TextField from 'shared/Forms/TextField'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import TextInput from 'shared/Inputs/TextInput'
import DateInput from 'shared/Inputs/DateInput'
import Modal from 'shared/Modal'
import ModalHeader from 'shared/Modal/ModalHeader'
import protectionApi from 'screens/Protection/protection.api'
import { useEffect, useState } from 'react'
import { toDateString } from '../../../../utils/formatDate'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { protectionAtom } from 'screens/Protection/protection.atom'
import protectionDayAtom from '../../ProtectionRooms/protectionDay.atom'

type Mode = 'create' | 'update'

interface IProps {
  type: Mode
  onClose?: () => void
  date?: Date | null
}
const DefenceModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const protectionDay = useRecoilValue(protectionDayAtom)
  const setCalendarState = useSetRecoilState(protectionAtom)
  const setCurrentDefence = useSetRecoilState(protectionDayAtom)
  const [state, setState] = useState({
    name: '',
    startsAt: props.date ? toDateString(props.date) : '',
    startsTime: '09:00',
    endsAt: props.date ? toDateString(props.date) : '',
    endsTime: '17:00',
  })

  const handleChange = (value: string, name: string) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  useEffect(() => {
    if (props.type !== 'update') return
    if (!protectionDay?.defence) return

    const starts = new Date(protectionDay.defence?.startsAt)
    const ends = new Date(protectionDay.defence?.endsAt)

    setState({
      name: protectionDay.defence.name ?? '',
      startsAt: toDateString(starts),
      startsTime: starts.toTimeString().slice(0, 5),
      endsAt: toDateString(ends),
      endsTime: ends.toTimeString().slice(0, 5),
    })
  }, [props.type, protectionDay])
  const handleSubmit = () => {
    const payload = {
      name: state.name,
      startsAt: `${state.startsAt}T${state.startsTime}:00.000Z`,
      endsAt: `${state.endsAt}T${state.endsTime}:00.000Z`,
    }

    const request =
      props.type === 'update'
        ? protectionApi.updateDefence(protectionDay!.defence.id, payload)
        : protectionApi.createDefence(payload)

    wait(request, (resp) => {
      if (resp.status === 'success') {
        if (props.type == 'create') {
          setCalendarState((prev) => ({
            ...prev,
            items:
              props.type === 'update'
                ? prev.items.map((item) => (item.id === resp.body.id ? resp.body : item))
                : [...prev.items, resp.body],
          }))
        } else {
          setCurrentDefence((prev) => {
            if (!prev) return prev

            return {
              ...prev,
              defence: resp.body,
            }
          })
        }

        props.onClose?.()
      }
    })
  }

  return (
    <Modal onClose={props.onClose} size='md'>
      <ModalHeader onClose={props.onClose}>
        {props.type == 'create' ? 'Создание защиты' : 'Обновление защиты'}
      </ModalHeader>

      <div className='modal-content'>
        <div className='flex-lines'>
          <TextField header='Название защиты'>
            <TextInput name='name' value={state.name} onChange={handleChange} placeholder='Spring Defence 2026' />
          </TextField>

          <TextField header='Дата начала'>
            <DateInput name='startsAt' date={state.startsAt} onChange={handleChange} />
          </TextField>

          <TextField header='Время начала'>
            <TextInput type='time' name='startsTime' value={state.startsTime} onChange={handleChange} />
          </TextField>

          <TextField header='Дата окончания'>
            <DateInput name='endsAt' date={state.endsAt} onChange={handleChange} />
          </TextField>

          <TextField header='Время окончания'>
            <TextInput type='time' name='endsTime' value={state.endsTime} onChange={handleChange} />
          </TextField>
        </div>
      </div>

      <div className='modal-footer'>
        <Button style={{ width: 'fit-content' }} theme='primary' onClick={handleSubmit} loading={loading}>
          Сохранить
        </Button>
      </div>
    </Modal>
  )
}

export default DefenceModal
